const PROTECTED = 'textarea, input, select, [contenteditable]:not([contenteditable="false"]), .gj-page-wrap canvas';

// Elements a toy must never transform/filter: typed text, inputs, and the rendered page.
export function isProtectedElement(el: Element | null): boolean {
  if (!el) return false;
  if (el.closest(PROTECTED)) return true;
  if (el.querySelector(PROTECTED)) return true;
  return false;
}
